import { createApp, h } from 'vue';
import i18n from "../plugins/i18n";
import vuetify from '../plugins/vuetify';

export const initWidget = (id, Widget, dependencies = {}) => {
  const elements = document.querySelectorAll(`[id^=app-${id}]`);

  Array.prototype.forEach.call(elements, element => {
    const attributeNames = element?.getAttributeNames().filter(name => name !== 'id') || [];
    const props = attributeNames.reduce((p, attrName) => {
      try {
        p[attrName.replace('data-', '')] = JSON.parse(element?.getAttribute(attrName));
      } catch (e) {
        p[attrName.replace('data-', '')] = element?.getAttribute(attrName);
      }
      return p;
    }, {});

    const app = createApp({
      render: () => h(Widget, { ...props })
    });

    app.use(vuetify);
    app.use(i18n);

    Object.assign(app, dependencies); // If dependencies need to be added to the app instance

    app.mount(`#${element.id}`);
  });
};
